<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.14202 11.8563C9.74565 11.8563 11.8563 9.74565 11.8563 7.14202C11.8563 4.53839 9.74565 2.42773 7.14202 2.42773C4.53839 2.42773 2.42773 4.53839 2.42773 7.14202C2.42773 9.74565 4.53839 11.8563 7.14202 11.8563Z"
            stroke="#3D3C3B"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M13.5723 13.5723L10.5723 10.5723" stroke="#3D3C3B" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>

<script>
export default {
    name: 'SearchLight',
};
</script>
